// log the pageview with their URL
export const pageview = (url) => {
  window.gtag('config', 'UA-136963549-4', {
    page_path: url,
  })
}

// log specific events happening.
export const event = ({ action, params }) => {
  window.gtag('event', action, params)
}

// log click events happening.
export const clickEvent = (label) => {
  event({ action: 'click', params: {'event_label': label} })
}